import { Component, Input } from '@angular/core';
import { ModalController, AlertController, IonicModule } from '@ionic/angular';
import { Venue } from '../../models/models';
import { Storage } from '@ionic/storage-angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserDataProvider } from '../../providers/user-data/user-data';

/**
 * Generated class for the VenueSelectionPopoverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-venue-selection-popover',
  templateUrl: 'venue-selection-popover.html',
  styleUrls: ['./venue-selection-popover.scss'],
  standalone: false,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    TranslateModule
  ]
})
export class VenueSelectionPopoverPage {
  public static PATH: string = 'venueselectionpopover';

  @Input() public venues: Array<Venue>;
  @Input() private selectedVenue: Venue;

  constructor(
    public viewCtrl: ModalController,
    private events: AppEventService,
    private storage: Storage,
    public alertCtrl: AlertController,
    private translateService: TranslateService,
    private userData: UserDataProvider) {
      console.log("venue-selection-popover - constructor");

//      this.venues = this.navParams.data.venues;
//      this.selectedVenue = navParams.data.selectedVenue;
  }

  onSelectVenue(venue: Venue) {
    console.log('venue-selection-popover - selected venue:', venue.id, "selected venue", (this.selectedVenue ? this.selectedVenue.id : null));
    if (!this.selectedVenue || venue.id != this.selectedVenue.id) {
      if (this.selectedVenue != null) {
        this.selectedVenue.selected = false;
      }
      venue.selected = true;
      this.userData.init().then(() => {
        this.storage.set('selected-venue', JSON.stringify(venue));
        this.events.publish("venue:selected", venue);
        this.viewCtrl.dismiss();
      });
    } else {
      this.onClearVenue();
    }
  }

  onClearVenue() {
    console.log('venue-selection-popover - deselected venue');
    this.selectedVenue.selected = false;
    this.events.publish("venue:deselected");
    this.userData.init().then(() => {
      this.storage.set('selected-venue', null);
      this.viewCtrl.dismiss();
    });
  }

  locationHelpPressed() {
    this.alertCtrl.create({
      header: this.translateService.instant("SORTANDFILTER.LOCATION_FILTER"),
      subHeader: this.translateService.instant("HELP.VENUE_FILTER_DESCRIPTION"),
      buttons: [this.translateService.instant('GENERAL.OK')]
    }).then((ac) => ac.present());
  }
}
